<template>
    <div v-if="blok" v-editable="blok" data-test="NewL4Testimonial">
        <div
            class="testimonials"
            :class="{ 'testimonials--landing': blok.landing_page }"
            :style="{
                backgroundImage: blok.landing_page ? `url('${getImage(tileImage, 300, 50)}')` : '',
            }"
        >
            <div class="testimonials__container" :class="{ 'md:container': !blok.landing_page }">
                <div class="testimonials__wrapper">
                    <div class="testimonials__stars">
                        <NuxtIcon name="ri:star-fill" />
                        <NuxtIcon name="ri:star-fill" />
                        <NuxtIcon name="ri:star-fill" />
                        <NuxtIcon name="ri:star-fill" />
                        <NuxtIcon name="ri:star-fill" />
                    </div>
                    <div class="testimonials__review">{{ blok.review }}</div>
                    <div class="testimonials__reviewer">{{ blok.reviewer_name }}, {{ blok.reviewer_location }}</div>
                    <div class="testimonials__summary">
                        <template v-if="showDefaults">
                            {{ defaultName }} {{ defaultReviewsText }}: <span>{{ averageScore }}%</span> ({{
                                totalReviews
                            }})
                        </template>
                        <template v-else>
                            {{ blok.manual_product_name }} {{ defaultReviewsText }}:
                            <span>{{ blok.manual_average_score }}%</span>
                            ({{ blok.manual_total_reviews }})
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { IL4Testimonial } from '~/types';

const { blok } = defineProps<{ blok: IL4Testimonial }>();

const route = useRoute();

const {
    average_score: averageScore = 94,
    total_reviews: totalReviews = 38699,
    name: defaultName = route.params.testimonialProductName || 'Airport',
} = blok.review_what?.content || {}; //TODO remove

const { t } = useI18n();
const defaultReviewsText = t('testimonials.reviews');

const tileImage: ComputedRef<string> = computed(() => blok.background_image?.filename);

// If one of fields is missing, show default values
const showDefaults = computed(
    () => !blok.manual_average_score || !blok.manual_product_name || !blok.manual_total_reviews
);
</script>

<style lang="postcss" scoped>
.testimonials {
    @apply mb-4;
    &--landing {
        background-size: 330px auto;
        @apply mb-0 bg-primary;
    }
    &__container {
        @apply text-center text-white px-2 sm:px-0;
    }
    &__wrapper {
        @apply bg-white py-2 sm:py-4;
        .testimonials--landing & {
            @apply bg-transparent py-8 sm:pt-8 sm:pb-10;
        }
    }
    &__stars {
        @apply relative text-center;
        .iconify {
            @apply inline-block bg-yellow-500 text-5xl mx-2;
        }
        .testimonials--landing & {
            @apply my-5 sm:mb-8;
        }
    }
    &__review {
        @apply text-primary text-xl italic px-4 leading-none mb-2 sm:mb-3;
        .testimonials--landing & {
            @apply mb-8 sm:mb-8 text-2xl sm:text-4xl text-white;
        }
    }
    &__reviewer {
        @apply text-black font-bold px-4;
        .testimonials--landing & {
            @apply mb-6 text-lg font-normal text-white;
        }
    }
    &__summary {
        @apply text-base text-black px-4;
        .testimonials--landing & {
            @apply text-white text-lg;
        }
        span {
            @apply text-primary font-bold;
            .testimonials--landing & {
                @apply text-amber-500 font-normal;
            }
        }
    }
}
</style>
